export enum LoanOriginationSystemTasksFiltersActionTypes {
  SetSearchInputValue = 'loanOriginationSystemTasksFilters/setSearchInputValue',
  ToggleFiltersPopup = 'loanOriginationSystemTasksFilters/toggleFiltersPopup',
  ChangePopupFilters = 'loanOriginationSystemTasksFilters/changePopupFilters',
  FilterTasksByMembers = 'loanOriginationSystemTasksFilters/filterTasksByMembers',
  ResetAllFilters = 'loanOriginationSystemTasksFilters/resetAllFilters',
}
